export default class ForumEntityClass {
  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: ForumEntityClass): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): ForumEntityClass {
    return new ForumEntityClass("");
  }

  public fromJSON(value: string): ForumEntityClass {
    return new ForumEntityClass(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): ForumEntityClass {
    return new ForumEntityClass(this.value);
  }
}
